import { useQuery } from '@tanstack/react-query';
import fetchData from '../fetcher';
import type { UserResponse } from './types';
import { useMyOgnizationStore, useUserStore } from '@/store';

const persistMe = (response: UserResponse) => {
  const user = response?.data;
  if (!user) return response;

  useUserStore.getState().setUser(user);

  if (user.organizationId) {
    useMyOgnizationStore.getState().setCurrentOrganization(user.organizationId);
  }

  return response;
};

export const useMe = (isEnabled = true) => {
  const { data, error, isLoading, isError, isFetching, isSuccess } = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const response = await fetchData<UserResponse>('/iam/v4/iam/me', {
        method: 'GET',
        credentials: 'include',
      });
      return persistMe(response);
    },
    enabled: isEnabled,
  });

  return {
    data: data?.data,
    error,
    isLoading,
    isError,
    isFetching,
    isSuccess,
  };
};
